import React, { useState, useLayoutEffect, useEffect } from 'react';
import difference from 'lodash/difference';
import isEmpty from 'lodash/isEmpty';
import { SHARED_PASSAGE } from '../modules/utility/const';

const StickyHandler = (props) => {
  const {
    learnosityData: { app },
  } = props;

  const [sticky, setSticky] = useState(false);
  const [modalElementScrollTop, setModalElementScrollTop] = useState(0);
  const [currentStimulusKeys, setCurrentStimulusKeys] = useState([]);
  const [windowScrollPositionY, setWindowScrollPositionY] = useState(0);

  useLayoutEffect(() => {
    const startPosition = () => {
      // Scroll Position used when previewing items with a tall nav holding the Scoring Guide + Assign + Edit buttons
      if (document.querySelector('.nav') !== null) {
        return 120;
      }
      // Simple navigtion bar with question navigation using < > and question number
      return 80;
    };

    const scrollToTarget = (element, targetScroll) => {
      element.scrollTop = targetScroll;
    };

    const itemLoad = () => {
      const { features } = app.getCurrentItem();
      const screenModal = document.querySelector('.ScreenModal');

      const navigationElement = document.querySelector('.Navigation');
      if (sticky && !navigationElement.classList.contains('sticky')) {
        navigationElement.classList.add('sticky');
      }
      if (!sticky && navigationElement.classList.contains('sticky')) {
        navigationElement.classList.remove('sticky');
      }

      const matches = features
        .filter((item) => item.type === SHARED_PASSAGE)
        .map((feature) => feature.feature_id);

      // Handle the Student's Player where there's no ScreenModal element
      if (screenModal === null) {
        if (!isEmpty(currentStimulusKeys, matches)) {
          window.scrollTo(0, 10);
        } else {
          window.scrollTo(0, windowScrollPositionY);
        }
      }

      if (sticky && screenModal !== null) {
        if (
          (!isEmpty(matches) || !isEmpty(currentStimulusKeys)) &&
          isEmpty(difference(currentStimulusKeys, matches))
        ) {
          scrollToTarget(screenModal, modalElementScrollTop);
        } else {
          scrollToTarget(screenModal, startPosition());
        }
      }

      setCurrentStimulusKeys(matches);
    };

    app.on('item:load', itemLoad);

    return () => {
      app.off('item: load', itemLoad);
    };
  }, [sticky, modalElementScrollTop, windowScrollPositionY]);

  useEffect(() => {
    const onWindowScroll = () => {
      setWindowScrollPositionY(window.scrollY);
    };

    const onScroll = () => {
      const modalElement = document.querySelector('.ScreenModal');

      const navigationElement = document.querySelector('.Navigation');
      const previewItemElement = document.querySelector('.PreviewItem');
      if (modalElement.scrollTop > previewItemElement?.offsetTop && !sticky) {
        navigationElement.classList.add('sticky');
        setSticky(true);
      }
      if (modalElement.scrollTop < 75 && sticky) {
        navigationElement.classList.remove('sticky');
        setSticky(false);
      }

      setModalElementScrollTop(modalElement.scrollTop);
    };

    const screenModal = document.querySelector('.ScreenModal');
    if (screenModal) {
      screenModal.addEventListener('scroll', onScroll);
    } else {
      window.addEventListener('scroll', onWindowScroll);
    }

    // returned function will be called on component unmount
    return () => {
      if (screenModal) {
        screenModal.removeEventListener('scroll', onScroll);
      } else {
        window.removeEventListener('scroll', onWindowScroll);
      }
    };
  }, [sticky]);

  return null;
};

function areEqual() {
  return true;
}
const Sticky = React.memo(StickyHandler, areEqual);

export default Sticky;
